import { AgentRoles, ManagerRoles, UserRole } from '../../types';
import {
  assetLinkedTasksFilters,
  orgLinkedTasksFilters,
  taskListFilters,
  teamLinkedTasksFilters,
  userLinkedTasksFilters,
} from './taskFilters';
import { userProfilePagesVisibility } from './userProfilePagesVisibility';

/*
 Permissions mapping object which should be kept fairly flat, suggested level would be page. However cases like "filters"
 that span multiple pages are probably safer as typed objects and spread in.

 For traceability, if the mapping does not come from a golden source (e.g. the confluence page then referencing ticket)
*/
export const permissionMapping = {
  asset: {
    assetLinkedTasksFilters,
    linkTask: ManagerRoles,
    viewLinkedTask: [...ManagerRoles, UserRole.SUPP_SPR, UserRole.SUPP, UserRole.SVCUSR, UserRole.SVCUSR_SPR], // JIRA: AP-1286
    removeLinkedTask: ManagerRoles, // JIRA: AP-1286
    linkPpl: [...ManagerRoles, UserRole.SUPP_SPR, UserRole.SVCUSR_SPR],
  },
  assetList: {
    createAssetOrgIsRequired: [UserRole.OWNER, UserRole.OWNER_SPR], // fe issue: 1027
  },
  org: {
    orgLinkedTasksFilters,
    editOrg: [...AgentRoles, UserRole.OWNER_SPR, UserRole.SVCUSR_SPR, UserRole.SUPP_SPR],
    linkTask: ManagerRoles, // JIRA: AP-1285
    viewLinkedTask: [...ManagerRoles, UserRole.SUPP_SPR, UserRole.SUPP, UserRole.SVCUSR, UserRole.SVCUSR_SPR], // JIRA: AP-1286
    removeLinkedTask: ManagerRoles, // JIRA: AP-1286
  },
  messageList: {
    canSelectParticipants: ManagerRoles,
    canDisableReplies: ManagerRoles,
  },
  thread: {
    canDisableReplies: ManagerRoles,
  },
  peopleList: {
    inviteUserOrgIsRequired: [UserRole.SVCUSR_SPR, UserRole.SUPP_SPR, UserRole.OWNER, UserRole.OWNER_SPR], // fe issue: 1028
  },
  taskList: {
    createTaskOrgIsRequired: [UserRole.OWNER, UserRole.OWNER_SPR], // fe issue: 1026
    taskListFilters,
  },
  taskNotes: {
    canViewNotesList: ManagerRoles,
    canAddNote: ManagerRoles,
  },
  team: {
    inviteUserOrgIsRequired: [UserRole.SVCUSR_SPR, UserRole.SUPP_SPR, UserRole.OWNER, UserRole.OWNER_SPR], // fe issue: 1028
    editTeam: [UserRole.AGENT_SPR, UserRole.CLIENT_ADMIN, UserRole.PLAT_ADMIN],
    linkTask: [UserRole.AGENT_SPR, UserRole.CLIENT_ADMIN, UserRole.PLAT_ADMIN],
    linkAsset: [UserRole.AGENT_SPR, UserRole.CLIENT_ADMIN, UserRole.PLAT_ADMIN],
    removeLinkedTask: [UserRole.AGENT_SPR, UserRole.CLIENT_ADMIN, UserRole.PLAT_ADMIN],
    removeLinkedAsset: [UserRole.AGENT_SPR, UserRole.CLIENT_ADMIN, UserRole.PLAT_ADMIN],
    teamLinkedTasksFilters,
  },
  user: {
    userLinkedTasksFilters,
    userProfilePagesVisibility,
    linkTask: ManagerRoles,
    viewLinkedTask: [...ManagerRoles, UserRole.SUPP_SPR, UserRole.SUPP, UserRole.SVCUSR, UserRole.SVCUSR_SPR], // JIRA: AP-1286
    removeLinkedTask: ManagerRoles, // JIRA: AP-1286
    isManager: ManagerRoles,
  },
};
